import AppBar from '@mui/material/AppBar';
import { ThemeProvider } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectFooterTheme } from 'app/store/fuse/settingsSlice';
import clsx from 'clsx';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Typography } from '@mui/material';
import QrScanner from 'src/app/main/admin/qr/QrScanner';
import { useTranslation } from 'react-i18next';
import { TransitionProps } from '@mui/material/transitions';
import SeriaDialog from 'src/app/main/admin/qr/SeriaDialog';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


function FooterLayout1(props) {
  const { t } = useTranslation('translate-language');
  const footerTheme = useSelector(selectFooterTheme);
  const [footer, setFooter] = useState(true);
  const location = useLocation();
  const { pathname } = location;
  const [isScanning, setIsScanning] = useState(false);
  const [open, setOpen] = useState(false);
  const [seria, setSeria] = useState('');
  const handleScanResult = (resultText) => {
    setSeria(resultText)
    setOpen(true)
  };
  function checkSlashes(link) {
    const slashCount = (link.match(/\//g) || []).length;
    return slashCount <= 1;
  }

  useEffect(() => {

    if (pathname == "/calendar/workingstaff") {
      setFooter(true)
    }
    else {
      setFooter(checkSlashes(pathname))
    }

  }, [pathname]);


  const handleClose = (e) => {
    setOpen(false)
  }

  return (
    <ThemeProvider theme={footerTheme} className="">
      <AppBar
        id="fuse-footer"
        className={clsx('relative z-20 shadow-md bg-[#f1f5f9] ', props.className, !footer && "hidden")}
        color="default"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? footerTheme.palette.background.paper
              : footerTheme.palette.background.paper,
        }}
      >
        <Toolbar

          className="lg:hidden inline min-h-48 md:min-h-64 px-8 sm:px-12 py-8 flex justify-evenly items-center overflow-x-auto bg-white text-gray rounded-[36px] mb-12 mx-16"
        >
          {/* Asosiy */}
          <Typography component={Link} to="/home" type='text' color="primary" className="text-end block cursor-pointer !no-underline text-center">
            <div className={`flex flex-col items-center   ${pathname == "/home" ? `text-["#4f47e5"]` : `text-gray-500`}`}>
              <FuseSvgIcon className="w-32 h-32">heroicons-outline:home</FuseSvgIcon>
              <span className="text-xs no-underline">Asosiy</span>
            </div>
          </Typography>

          <Typography component={Link} to="/sales" type='text' color="primary" className="text-end block cursor-pointer !no-underline">
            <div className={`flex flex-col items-center   ${pathname == "/sales" ? `text-["#4f47e5"]` : `text-gray-500`}`}>
              <FuseSvgIcon className="w-32 h-32">feather:shopping-bag</FuseSvgIcon>
              <span className="text-xs no-underline">Sotuv</span>
            </div>
          </Typography>



          {/* QR Scanner – o‘rtada, yuqoriroq joylashgan */}
          <QrScanner
            isScanning={isScanning}
            setIsScanning={setIsScanning}
            onScanResult={handleScanResult}
          />

          {/* QR tugma */}
          <div
            className="flex flex-col items-center -mt-8 text-secondary rounded-full p-3 bg-[#d5ecff] shadow-lg z-100 cursor-pointer"
            onClick={(e) => {
              setIsScanning(true)
              // setOpen(true)
            }}
          >
            <div className='w-48 h-48 flex justify-center items-center'>
              <FuseSvgIcon color="secondary" className="w-28 h-28">
                material-twotone:qr_code_scanner
              </FuseSvgIcon>
            </div>
          </div>

          {/* Tarix */}


          <Typography component={Link} to="/purchase" type='text' color="primary" className="text-end block cursor-pointer !no-underline">
            <div className={`flex flex-col items-center   ${pathname == "/purchase" ? `text-["#4f47e5"]` : `text-gray-500`}`}>
              <FuseSvgIcon className="w-32 h-32">feather:shopping-cart</FuseSvgIcon>
              <span className="text-xs no-underline">Import</span>
            </div>
          </Typography>



          {/* Profil */}
          <Typography component={Link} to="/profile" type='text' color="primary" className="text-end block cursor-pointer !no-underline">
            <div className={`flex flex-col items-center   ${pathname == "/profile" ? `text-["#4f47e5"]` : `text-gray-500`}`}>
              <FuseSvgIcon className="w-32 h-32">heroicons-outline:user</FuseSvgIcon>
              <span className="text-xs no-underline">Profil</span>
            </div>
          </Typography>
        </Toolbar>

      </AppBar>

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        color='secondary'
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiDialog-paper": {
            position: 'fixed',
            bottom: 0,
            background: 'white',
            color: 'black',
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            borderRadius: '12px 12px 0 0', // optional: rounded top
            height: 'calc(100vh - 30%)', // ekranning yarmidan pastki qismi
          },
        }}

      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className='bg-grey-100'
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: "black",
          }}
        >
          <FuseSvgIcon className="text-48 text-black " size={28} color="action">material-twotone:close</FuseSvgIcon>
        </IconButton>
        <DialogTitle>{t("ProductHistory")}</DialogTitle>
        <DialogContent className=' text-2xl  justify-around'>
          <SeriaDialog seria={seria} />
        </DialogContent>

      </Dialog>
    </ThemeProvider>
  );
}

export default memo(FooterLayout1);
